// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"66":"b8ccb211","84":"6bc0897b","116":"177a2405","152":"ab1315d9","461":"443d4e78","513":"395f7e41","522":"532ff3c7","578":"2b5b7145","724":"56497231","746":"39d9dd48","786":"1c501ad6","793":"8e3819c2","820":"9d3ab1d6","929":"96d84eac"}[chunkId] + ".js";
};